import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AuthStore, RemoteConfigStore } from '@store';

@Component({
  selector: 'app-access-forbidden',
  templateUrl: './access-forbidden.component.html',
  styleUrls: ['./access-forbidden.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccessForbiddenComponent {
  constructor(public authStore: AuthStore, public remoteConfigStore: RemoteConfigStore) {}
}
